import Cookies from 'js-cookie';
var UtmNameInQuery;
(function (UtmNameInQuery) {
    UtmNameInQuery["CAMPAIGN"] = "utm_campaign";
    UtmNameInQuery["CONTENT"] = "utm_content";
    UtmNameInQuery["MEDIUM"] = "utm_medium";
    UtmNameInQuery["SOURCE"] = "utm_source";
    UtmNameInQuery["TERM"] = "utm_term";
})(UtmNameInQuery || (UtmNameInQuery = {}));
var UtmNameInCookie;
(function (UtmNameInCookie) {
    UtmNameInCookie["CAMPAIGN"] = "__PW_UTM_CAMPAIGN";
    UtmNameInCookie["CONTENT"] = "__PW_UTM_CONTENT";
    UtmNameInCookie["MEDIUM"] = "__PW_UTM_MEDIUM";
    UtmNameInCookie["SOURCE"] = "__PW_UTM_SOURCE";
    UtmNameInCookie["TERM"] = "__PW_UTM_TERM";
})(UtmNameInCookie || (UtmNameInCookie = {}));
function getQueryParam(name) {
    return new URLSearchParams(window.location.search).get(name);
}
(function () {
    var campaign = getQueryParam(UtmNameInQuery.CAMPAIGN);
    var content = getQueryParam(UtmNameInQuery.CONTENT);
    var medium = getQueryParam(UtmNameInQuery.MEDIUM);
    var source = getQueryParam(UtmNameInQuery.SOURCE);
    var term = getQueryParam(UtmNameInQuery.TERM);
    // если это внутренние переходы по ссылкам, то игнорируем utm метки
    if (content === 'pwwebsite' || source === 'pwwebsite') {
        return;
    }
    var api = Cookies.withAttributes({ path: '/', domain: '.pushwoosh.com', expires: 365 / 2 });
    // иначе, если есть utm метки, то сохраняем их в куки
    if (campaign) {
        api.set(UtmNameInCookie.CAMPAIGN, campaign);
    }
    if (content) {
        api.set(UtmNameInCookie.CONTENT, content);
    }
    if (medium) {
        api.set(UtmNameInCookie.MEDIUM, medium);
    }
    if (source) {
        api.set(UtmNameInCookie.SOURCE, source);
    }
    if (term) {
        api.set(UtmNameInCookie.TERM, term);
    }
})();
